var jingdian = [
    // —————— 中山区 ——————
    [121.675131, 38.879093, '老虎滩海洋公园'],
    [121.805433, 39.000138, '大连滨海路'],
    [121.632301, 38.866924, '燕窝岭风景区'],
    [121.668688, 38.865431, '北大桥'],
    [121.625370, 38.866715, '付家庄公园'],
    [121.704714, 38.889421, '棒棰岛景区'],
    [121.657531, 38.910620, '大连植物园'],
    [121.635465, 38.927868, '俄罗斯风情街'],
    [121.561483, 38.870555, '大连自然博物馆'],

    // —————— 西岗区 ——————
    [121.621129, 38.888165, '大连森林动物园'],
    [121.829439, 39.070947, '劳动公园'],
    [121.603965, 38.907161, '大连奥林匹克广场'],
    [121.614786, 38.913962, '大连现代博物馆'],
    [121.617398, 38.911588, '人民广场'],

    // —————— 沙河口区 ——————
    [121.588870, 38.882379, '星海广场'],
    [121.568075, 38.877811, '星海公园'],
    [121.572370, 38.879976, '圣亚海洋世界'],
    [121.589435, 38.878222, '贝壳博物馆'],
    [122.381430, 39.211017, '黑石礁公园'],
    [121.549263, 38.875585, '大连交通大学樱花大道'],

    // —————— 甘井子区 ——————
    [121.542585, 38.964154, '大连周水子国际机场观景台'],
    [121.765475, 39.039445, '大连中华路体育公园'],
    [122.975774, 40.009982, '大连华南广场儿童游乐区'],
    [121.664004, 39.027679, '大连欢童谷户外亲子乐园'],
    [121.661445, 39.036930, '大连前关湿地公园'],

    // —————— 旅顺口区 ——————
    [121.235041, 38.809167, '旅顺博物馆'],
    [121.260907, 38.807961, '白玉山景区'],
    [121.284626, 38.835619, '东鸡冠山北堡垒景区'],
    [121.616631, 38.978960, '203樱花园'],
    [121.997274, 39.731921, '太阳沟历史文化街区'],
    [121.260451, 38.804738, '旅顺军港'],
    [121.141465, 38.730717, '老铁山黄渤海分界线'],

    // —————— 金普新区（含原金州区、开发区） ——————
    [122.002284, 39.076956, '金石滩国家旅游度假区'],
    [121.999464, 39.079975, '发现王国主题公园'],
    [122.002684, 39.082295, '金石滩地质公园'],
    [122.980311, 39.641127, '鲁能海洋温泉'],
    [121.803057, 39.496925, '铭湖温泉'],
    [121.958054, 39.072837, '汤景泽日式温泉'],
    [121.776543, 39.112341, '大黑山风景区'],
    [121.913078, 39.305157, '小黑山风景区'],
    [121.425014, 38.883107, '横山寺'],
    [121.879414, 39.335741, '野趣乐园（石河街道）'],
    [121.901316, 39.334504, '东沟五坊民俗村'],

    // —————— 普兰店区 ——————
    [121.980627, 39.084299, '安波温泉旅游度假区'],
    [121.267470, 38.840353, '二龙山景区'],
    [122.309752, 39.636576, '巍霸山城'],
    [121.989669, 39.339951, '唐房水库生态园'],

    // —————— 瓦房店市 ——————
    [121.980627, 39.084299, '仙浴湾旅游度假区'],
    [121.707729, 39.732802, '复州古城'],
    [121.589879, 39.859788, '驼山溶洞'],
    [120.305018,30.473331, '永宁寺'],
    [121.980627, 39.084299, '大连龙门旅游度假区'],

    // —————— 庄河市 ——————
    [122.986573, 39.986312, '冰峪沟风景区'],
    [122.680782,40.002437, '步云山温泉度假区'],
    [122.902226, 40.161964, '天门山国家森林公园'],
    [123.085966, 39.442179, '海王九岛'],
    [122.999034, 39.897661, '银石滩国家森林公园'],

    // —————— 长海县 ——————
    [122.578703, 39.279215, '大长山岛'],
    [122.690085, 39.238618, '小长山岛'],
    [122.355650, 39.181804, '广鹿岛'],
    [123.178010, 39.061470, '海洋岛'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [121.675131, 38.879093, '老虎滩海洋公园'],
    [121.572370, 38.879976, '圣亚海洋世界'],
    [121.621129, 38.888165, '大连森林动物园'],
    [121.999464, 39.079975, '发现王国主题公园'],
    [121.879414, 39.335741, '野趣乐园（石河街道）'],
    [121.568075, 38.877811, '星海公园（儿童攀爬区）'],
    [121.829439, 39.070947, '劳动公园（游乐场+花展）'],
    [122.381430, 39.211017, '黑石礁公园（赶海体验）'],
    [121.506551, 39.716404, '仙浴湾（沙滩亲子游）'],
    [122.973110, 39.963048, '冰峪沟（夏季避暑+漂流）']
];

var dalian = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default dalian